import React from 'react';
import InterestWithholdingTaxVM from './InterestWithholdingTaxVM';
import { observer } from 'mobx-react';
import { Neo, NeoGrid } from '@singularsystems/neo-react';
import InterestWithholdingTaxLookup from '../Models/Lookups/InterestWithholdingTaxLookup';
import { TextConstants } from '../../../Common/TextConstants';
import { dateFormatYYYYMMDD } from '../../../Common/Components/Helpers/Formatting';

interface IInterestWithholdingTaxProps {
    viewModel: InterestWithholdingTaxVM;
}

@observer
export default class InterestWithholdingTax extends React.Component<IInterestWithholdingTaxProps> {

    constructor(props: IInterestWithholdingTaxProps) {
        super(props);
    }

    public render() {
        const viewModel = this.props.viewModel;

        return (
          <>
          <Neo.Card>
            {viewModel.interestWithholdingTaxPageManager.totalRecords > 0 && 
              
                <div className="inner-container">
                  <Neo.Pager
                    pageManager={viewModel.interestWithholdingTaxPageManager}
                    pageControlProps={{ pageSizeLabel: "Show" }}
                  >
                    <div className="horizontalScroll inner-container">
                      <NeoGrid.Grid<InterestWithholdingTaxLookup> className={"table-striped"}>
                        {(item, meta) => (
                          <NeoGrid.RowGroup>
                            <NeoGrid.Row>
                              <NeoGrid.Column display={meta.brokerAccountNumber} label={TextConstants.Labels.BrokerAccountNumber} />
                              <NeoGrid.Column display={meta.instrument} label={TextConstants.Labels.Instrument} />
                              <NeoGrid.Column display={meta.eventDetail} label={TextConstants.Labels.EventDetail} />
                              <NeoGrid.Column display={meta.eventID} label={TextConstants.Labels.EventID} />
                              <NeoGrid.Column label={TextConstants.Labels.EventDate} >{dateFormatYYYYMMDD(item.eventDate)}</NeoGrid.Column>
                              <NeoGrid.Column display={meta.amountNC} label={TextConstants.Labels.AmountNC}/>
                              <NeoGrid.Column display={meta.excluded} label={TextConstants.Labels.Excluded} />                             
                            </NeoGrid.Row>
                          </NeoGrid.RowGroup>
                        )}
                      </NeoGrid.Grid>
                    </div>
                  </Neo.Pager>
                </div>
                }
                {viewModel.interestWithholdingTaxPageManager.totalRecords <= 0 && (
                  <div className="col-md-12 p-0 text-center">
                    {TextConstants.GeneralText.NoRecords}
                  </div>
                )}
              </Neo.Card>
          </>
        );
    }
}